import React, {Component} from 'react'
import styles from './SchedulerDay.css'
import {SchedulerHour} from './SchedulerHour'
import {LAYOUT_TYPE_HORIZONTAL, LAYOUT_TYPE_VERTICAL} from './Scheduler'
import {renderHourNamed} from './scheduler-utils'
import SchedulerContext from './SchedulerContext'
import isEmpty from 'lodash/isEmpty'
import {formatDate} from '../../../utils/time'
import styled from 'styled-components'

const DaysText = styled.div`
  opacity: 0.9;
  font-size: 12px;
  letter-spacing: 0.4px;
  color: #191919;
`

const FieldTitleText = styled.div`
  font-size: 12px;
  color: #a4a9b7;
  font-weight: 600;
`
const renderDayNamed = (day, isVertical) => {
  return (
    <div
      className={
        isVertical ? styles.dayVerticalContent : styles.dayHorizontalContent
      }
    >
      <div key={0} className={styles.dayNumber}>
        {formatDate(day, 'D')}
      </div>
      <div key={1} style={{marginLeft: 8}}>
        <DaysText>{formatDate(day, 'MMM, YYYY')}</DaysText>
        <FieldTitleText>{formatDate(day, 'ddd')}</FieldTitleText>
      </div>
    </div>
  )
}

export class SchedulerDay extends Component {
  _context = {}
  _conflictTimes = {}

  state = {
    isExpand: false
  }

  constructor(props) {
    super(props)
    this.state = {
      isExpand: props.isExpand
    }
  }

  componentDidUpdate() {
    const {day} = this.props

    if (!isEmpty(this._conflictTimes)) {
      this._context.saveConflictPos({day: day.date})
      this._context.onSolveConflict(day.date, this._conflictTimes)
      this._conflictTimes = {}
    }
  }

  onExpand = () => {
    const value = !this.state.isExpand

    this._context.hideSelectedLayer()
    this.setState({
      isExpand: value
    })
    this._context.cleanDisplayConflict()
  }

  _renderContent = options => {
    this._context = options

    switch (options.layout) {
      case LAYOUT_TYPE_VERTICAL:
        return this._renderVerticalView()
      case LAYOUT_TYPE_HORIZONTAL:
        return this._renderHorizontalView()
      default:
        return <div />
    }
  }

  _renderHorizontalView = () => {
    const header = renderDayNamed(this.props.day.date)
    const cells = this._renderHours({isHorizontal: true})
    return (
      <div className={styles.horizontalView}>
        {header}
        {cells}
      </div>
    )
  }

  _renderVerticalView = () => {
    const {isExpand} = this.state
    const {day, displayConflict} = this.props
    const header = this._renderVerticalHeader()
    const cells = this._renderVerticalCells()

    let isOpen = isExpand
    if (displayConflict && displayConflict !== -1) {
      isOpen = displayConflict.day.format('Y-m-d') === day.date.format('Y-m-d')
      this.setState({
        isExpand: isOpen
      })
    }

    return (
      <div className={styles.verticalView}>
        {header}
        {isOpen && cells}
      </div>
    )
  }

  _renderVerticalHeader = () => {
    const {day} = this.props
    let {busy, selected} = day
    busy = busy.sort((a, b) => a.start > b.start)
    let busyTimeView = []
    if (busy.length !== 0) {
      busyTimeView = busy.map((item, idx) => {
        const start =
          (item.start ^ 0) === item.start
            ? item.start + ':00'
            : item.start - 0.5 + ':30'
        const end =
          (item.end ^ 0) === item.end
            ? item.end + ':00'
            : item.end - 0.5 + ':30'
        const times = start + ' - ' + end
        return (
          <div
            key={idx}
            className={
              item.conflict
                ? styles.schedulerHeaderBusyTimeConflict
                : styles.schedulerHeaderBusyTime
            }
          >
            {times}
          </div>
        )
      })
    }
    let selectedTimeView
    if (selected.start !== -1) {
      const endTime = selected.end + 0.5
      const start =
        (selected.start ^ 0) === selected.start
          ? selected.start + ':00'
          : selected.start - 0.5 + ':30'
      const end =
        (endTime ^ 0) === endTime ? endTime + ':00' : endTime - 0.5 + ':30'
      const times = start + ' - ' + end
      selectedTimeView = (
        <div className={styles.schedulerHeaderSelectedTime}>{times}</div>
      )
    }
    return (
      <div className={styles.horizontalView} onClick={this.onExpand}>
        {renderDayNamed(day.date, true)}
        <div className={styles.schedulerHeaderBusyTimeContent}>
          <div>
            {selectedTimeView}
            <div style={{display: 'flex', paddingTop: 5}}>{busyTimeView}</div>
          </div>
        </div>
      </div>
    )
  }

  _renderVerticalCells = () => {
    const {start, end} = this._context.workDates
    const {day} = this.props

    if (day.conflicted) {
      this._conflictTimes = {}
    }

    let time = start
    let idx = 1
    let hoursNamed = []

    while (time <= end) {
      hoursNamed.push(renderHourNamed(time, true, idx))
      time += 1
      idx++
    }
    let hours = this._renderHours({isHorizontal: false})
    return (
      <div className={styles.horizontalView}>
        <div className={styles.verticalView} style={{width: 120}}>
          {hoursNamed}
        </div>
        <div className={styles.verticalView}>{hours}</div>
      </div>
    )
  }

  _renderHours = ({isHorizontal}) => {
    const {day} = this.props
    let {start, end, postBlock} = this._context.workDates
    let time = start
    let idx = 1
    let hours = []

    const endTime = isHorizontal ? end + 0.5 - 1 - postBlock : end - 1;

    while (time <= endTime) {
      let blocks = 1
      const halfHour = this._configureHaftHour(time)
      if (halfHour.blocks > 1) {
        blocks = halfHour.blocks
      }
      hours.push(<SchedulerHour key={idx} time={time} {...halfHour} />)
      if (halfHour.conflict && !day.conflicted) {
        this._findEmptyCellForResolveConflict(time)
      }
      time += 0.5 * blocks
      idx++
    }

    return hours
  }

  _configureHaftHour = time => {
    const blocks = this._calcBusyBlocksForTime(time)
    const isBusy = this._isBusy(blocks)
    return {
      day: this.props.day.date,
      busy: isBusy,
      blocks: blocks === 0 ? 1 : blocks,
      selected: this._isSelect(time),
      conflict: this._isConflictCell(time, isBusy)
    }
  }

  _calcBusyBlocksForTime = time => {
    const {busy} = this.props.day

    if (!busy) return 0

    for (let i = 0; i < busy.length; i++) {
      const {start, blocks} = busy[i]
      if (start === time) {
        return blocks
      }
    }

    return 0
  }

  _isBusy = blocks => {
    return blocks !== 0
  }

  _isSelect = time => {
    const {start, end} = this.props.day.selected
    return time >= start && time <= end
  }

  _isConflictCell = (time, isBusy) => {
    if (!isBusy) return false

    const {busy} = this.props.day

    let busyBlocks = 1
    for (let i = 0; i < busy.length; i++) {
      const {start, blocks, conflict} = busy[i]
      if (start === time) {
        if (conflict) {
          return true
        }
        busyBlocks = blocks
        break
      }
    }

    let busyTime = time
    for (let i = 0; i < busyBlocks; i++) {
      if (this._isSelect(busyTime)) {
        return true
      }
      busyTime += 0.5
    }
    return false
  }

  _findEmptyCellForResolveConflict = conflictTime => {
    let conflictTimes = {
      date: this.props.day.date,
      conflicted: true,
      userResolveConflict: false,
      selected: {
        start: -1,
        end: -1
      },
      busy: []
    }

    const {workDates} = this._context
    const {busy, selected} = this.props.day
    const countSelectedBlocks =
      selected.end - selected.start === 0
        ? 1
        : (selected.end - selected.start + 0.5) * 2
    let conflictBlocks = 0

    for (let i = 0; i < busy.length; i++) {
      if (busy[i].start === conflictTime) {
        conflictTimes.busy.push({
          ...busy[i],
          conflict: true
        })
        conflictBlocks = busy[i].blocks
      } else {
        conflictTimes.busy.push(busy[i])
      }
    }

    let time = conflictTime + 0.5 * conflictBlocks
    let startTime = time
    let countCorrectly = 0
    while (time <= workDates.end) {
      let blocks = this._calcBusyBlocksForTime(time)
      if (this._isBusy(blocks)) {
        time += 0.5 * blocks - 0.5
        startTime = time
        countCorrectly = 0
      } else {
        countCorrectly++
      }
      if (countCorrectly === countSelectedBlocks) {
        conflictTimes.selected = {
          start: startTime,
          end: time
        }
        break
      }
      time += 0.5
    }
    this._conflictTimes = conflictTimes
  }

  render() {
    return (
      <div>
        <SchedulerContext.Consumer>
          {values => this._renderContent(values)}
        </SchedulerContext.Consumer>
      </div>
    )
  }
}
